// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetRedIndicator = () => ({
    type: actions.UPDATE_USER_PREFERENCES_REIMBURSEMENT_RED_INDICATOR,
    value: null
});

export const updateRedIndicator = value =>
    (dispatch, getState) => {

        dispatch({
            type: actions.UPDATE_USER_PREFERENCES_REIMBURSEMENT_RED_INDICATOR,
            value
        });

        value < getState().user.details.settings.reimbursementSummary.reimbursedPercentIndicator.yellow ?
            dispatch({
                data: false,
                type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
            }) :
            dispatch({
                data: true,
                type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
            });

    };

export const resetYellowIndicator = () => ({
    type: actions.UPDATE_USER_PREFERENCES_REIMBURSEMENT_YELLOW_INDICATOR,
    value: null
});

export const updateYellowIndicator = value =>
    (dispatch, getState) => {

        dispatch({
            type: actions.UPDATE_USER_PREFERENCES_REIMBURSEMENT_YELLOW_INDICATOR,
            value
        });

        value > getState().user.details.settings.reimbursementSummary.reimbursedPercentIndicator.red ?
            dispatch({
                data: false,
                type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
            }) :
            dispatch({
                data: true,
                type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
            });

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/reimbursement-summary-settings.js